import { useEffect, useState } from "react";
// REDUX
import { useGetProtocolsLightQuery } from "../../redux/protocols/protocolAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// INTERFACE
import { ProtocolLightInterface } from "../../interfaces/Protocols.interface";

export default function useGetAllProtocolsLight({ page = 1, limit = 999999 }: { page?: number; limit?: number }) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [protocols, setProtocols] = useState<ProtocolLightInterface[]>([]);
	const [token, setToken] = useState<string | null>(null);
	const [errorObject, setErrorObject] = useState<any>({});
	const [errorMessage, setErrorMessage] = useState<string>("Error");

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const { data, isLoading, isError, isFetching, error } = useGetProtocolsLightQuery(
		{ token, page, limit },
		{ skip: !token, refetchOnMountOrArgChange: false },
	);

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		GETJwtToken().then(setToken);
	}, []);

	useEffect(() => {
		if (data && data.data) {
			setProtocols(data.data);
		}
	}, [data]);

	useEffect(() => {
		if (error) {
			setErrorObject(error);
		}
	}, [error]);

	useEffect(() => {
		if (errorObject && errorObject.data && errorObject.data.message) {
			setErrorMessage(errorObject.data.message);
		}
	}, [errorObject]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return {
		protocolsLight: protocols,
		isLoadingGetAllProtocolsLight: isLoading || isFetching,
		errorMessageGetAllProtocolsLight: errorMessage,
		isErrorGetAllProtocolsLight: isError,
		totalRowsGetAllProtocolsLight: data?.total ?? 0,
	};
}
